module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-noneOption.f8e5a6a8.svg";